export default "<h2>検索履歴</h2>\n<ul>\n  <li><a data-type=\"delete-history\" href=\"javascript:void(0);\">×履歴をすべて削除</a></li>\n</ul>\n"